
import gql from 'graphql-tag';

export const UPDATERFIDFORDEASSOCIATION = gql`
mutation  updateRfidForDeassociation($input: updationIscertified){
  updateRfidForDeassociation(input:$input)
}
`;